// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"543":"86ec5f66","794":"86ec5f66"}[chunkId] + ".chunk.css";
};